import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Profile from './pages/Profile';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Challenges from './pages/Challenges';
import Challenge from './pages/Challenge';
import Connected from './pages/Connected';
import Login from './pages/Login';
import Admin from './pages/Admin';
import LearnPage from './pages/LearnPage';
import { ThemeProvider } from './context/ThemeContext';
import { AuthModalProvider } from './context/AuthModalContext';
import { supabase } from './supabase';
import Leaderboard from './pages/Leaderboard';
import InterviewPrep from './pages/InterviewPrep';
import Team from './pages/Team';
import TeamDashboard from './pages/TeamDashboard';
import Apex30 from './pages/Apex30';
import FormulaChallengeList from './pages/FormulaChallengeList';
import FormulaChallenge from './pages/FormulaChallenge';
import AuthModal from './components/AuthModal';
import { AuthProvider, useAuth } from "./context/AuthContext";
import { UserTierProvider }      from "./context/UserTierContext";
import Pricing                   from "./pages/Pricing";
import Flashcards from './pages/Flashcards';
import Dashboard from './pages/Dashboard';
import './App.css';

function AppRoutes() {
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session) {
        const currentPath = window.location.pathname;
        if (currentPath === '/login' || currentPath === '/connected') {
          navigate('/', { replace: true });
        }
      }
    });
  }, [navigate]);

  return (
    <>
      <AuthModal />
      <Routes>
        <Route path="/admin"                    element={<Admin />} />
        <Route path="/"                         element={<Home />} />
        <Route path="/challenges/:category"     element={<Challenges />} />
        <Route path="/challenge/:id"            element={<Challenge />} />
        <Route path="/connected"                element={<Connected />} />
        <Route path="/login"                    element={<Login />} />
        <Route path="/faq"                      element={<FAQ />} />
        <Route path="/contact"                  element={<Contact />} />
        <Route path="/profile"                  element={<Profile />} />
        <Route path="/learn/:topic"             element={<LearnPage />} />
        <Route path="/leaderboard"              element={<Leaderboard />} />
        <Route path="/interview"                element={<InterviewPrep />} />
        <Route path="/team"                     element={<Team />} />
        <Route path="/team/dashboard"           element={<TeamDashboard />} />
        <Route path="/join/:slug"               element={<Team />} />
        <Route path="/apex30"                   element={<Apex30 />} />
        <Route path="/challenges/formula"       element={<FormulaChallengeList />} />
        <Route path="/challenges/formula/:id"   element={<FormulaChallenge />} />
        <Route path="/pricing"                  element={<Pricing />} />
        <Route path="/flashcards"               element={<Flashcards />} />
        <Route path="/dashboard"                element={<Dashboard />} />
      </Routes>
    </>
  );
}
function UserTierProviderWrapper({ children }) {
  const { user, subscription } = useAuth();
  return (
    <UserTierProvider user={user} subscription={subscription}>
      {children}
    </UserTierProvider>
  );
}
function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <UserTierProviderWrapper>
          <AuthModalProvider>
            <AppRoutes />
          </AuthModalProvider>
        </UserTierProviderWrapper>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;